// --------------------------
// IMPORTS
// --------------------------
import { useState } from "react";
import { Link } from "react-router-dom";
import media from "../../media";

// --------------------------
// MAIN COMPONENT
// --------------------------
export default function DashboardPendingRequests(props) {
  const { dashboardPendingRequestsData, usersList } = props;

  // --------------------------
  // JSX RETURN
  // --------------------------
  return (
    <>
      <div className="d-flex justify-content-between p-5 b-bottom">
        <h3 className="card-label font-weight-bolder text-dark text-size-14 mb-1">
          Pending Requests
        </h3>
        <Link
          to="/pending-requests"
          className="font-size-md font-size-sm seeAll"
        >
          See All
        </Link>
      </div>
      <div className="p-5">
        {dashboardPendingRequestsData &&
        dashboardPendingRequestsData?.length > 0 ? (
          dashboardPendingRequestsData.map((item, index) => {
            const empInfo = usersList.find(
              (userItem) => userItem.empID === item.empID,
            );
            const deptID = empInfo?.departmentID;

            const initial = empInfo?.empName
              ? empInfo?.empName.charAt(0).toUpperCase()
              : "?";
            const imageUrl = empInfo?.profilePicUrl
              ? process.env.REACT_APP_BACKEND +
                "/images/" +
                empInfo?.profilePicUrl
              : media.user.png;

            return (
              <div className="d-flex align-items-center mb-5" key={index}>
                <div className="symbol symbol-30 mr-5">
                  {imageUrl ? (
                    <div className="symbol-circle">
                      <img
                        src={imageUrl}
                        alt={empInfo?.empName || "Employee"}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = media.user.png;
                        }}
                      />
                    </div>
                  ) : (
                    <span className="initialLetter">{initial}</span>
                  )}
                </div>
                <div className="d-flex flex-column flex-grow-1 font-weight-500">
                  <span className="text-size-12 mb-1 dark-black-color">
                    {empInfo?.empName}
                  </span>
                  <span className="light-grey-color text-size-10">
                    {empInfo?.departmentID}{" "}
                    {empInfo?.departmentCode
                      ? ` - ${empInfo?.departmentCode}`
                      : ""}
                  </span>
                </div>
                <div className="ml-2 dark-black-color text-size-12 font-weight-500">
                  {process.env.REACT_APP_DEFAULT_CURRENCY}
                  {item?.totalReimbursement}
                </div>
              </div>
            );
          })
        ) : (
          <center>No data found</center>
        )}
      </div>
    </>
  );
}
